import { type RefObject, createContext } from 'react';

/**
 * Context that holds a ref to a container element inside a dialog.
 * When present, `useToast()` automatically routes destructive toasts
 * to render inside the dialog rather than the global Sonner toaster.
 */
export const DialogToastRefContext =
  createContext<RefObject<HTMLElement | null> | null>(null);
